import { render, staticRenderFns } from "./ManageWarrantsWithoutSettlements.vue?vue&type=template&id=066140ec&scoped=true"
import script from "./ManageWarrantsWithoutSettlements.vue?vue&type=script&lang=js"
export * from "./ManageWarrantsWithoutSettlements.vue?vue&type=script&lang=js"
import style0 from "./ManageWarrantsWithoutSettlements.vue?vue&type=style&index=0&id=066140ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066140ec",
  null
  
)

export default component.exports